import React, { useEffect, useState } from "react";
import { Box, Grid, IconButton, Modal, Typography } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";

function ColonyFullPage({ service }) {
    const [photos, setPhotos] = useState([]);
    const [open, setOpen] = useState(-1);

    const handleClose = () => setOpen(-1);

    useEffect(() => {
        const loadPhotos = async () => {
            let indents = [];
            for (let i = 0; i < service?.photos?.length; i += 1) {
                indents.push(
                    <img
                        id={i}
                        onClick={(e) => {
                            setOpen(i);
                        }}
                        src={service.photos[i]}
                        width={"350px"}
                        height={"175px"}
                        alt="imagem de colonias"
                        style={{
                            objectFit: "cover",
                            minWidth: "200px",
                        }}
                    />
                );
            }

            setPhotos(indents);
        };

        const loadPhotosList = async () => {
            let indents = service?.photos?.map((item, i) => (
                <img
                    id={i}
                    onClick={(e) => {
                        setOpen(i);
                    }}
                    src={item}
                    width={"350px"}
                    height={"175px"}
                    alt="imagem de colonias"
                    style={{
                        objectFit: "cover",
                        minWidth: "200px",
                    }}
                />
            ));

            setPhotos(indents);
        };

        if (service.photos && service?.photos?.length !== 0) {
            loadPhotosList();
        } else {
            loadPhotos();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Box marginBottom={2} p={4}>
            <Modal
                open={open === -1 ? false : true}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box
                    style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        p: 4,
                    }}
                >
                    <Typography
                        id="modal-modal-title"
                        component="h2"
                        sx={{
                            position: "absolute",
                            width: 1,
                            height: 1,
                            padding: 0,
                            margin: -1,
                            overflow: "hidden",
                            clip: "rect(0, 0, 0, 0)",
                            whiteSpace: "nowrap",
                            border: 0,
                        }}
                    >
                        Foto em visualização ampliada
                    </Typography>
                    <Typography
                        id="modal-modal-description"
                        component="p"
                        sx={{
                            position: "absolute",
                            width: 1,
                            height: 1,
                            padding: 0,
                            margin: -1,
                            overflow: "hidden",
                            clip: "rect(0, 0, 0, 0)",
                            whiteSpace: "nowrap",
                            border: 0,
                        }}
                    >
                        Imagem da colônia
                    </Typography>
                    {parseInt(open) !== 0 && (
                        <IconButton
                            aria-label="Foto anterior"
                            onClick={() => {
                                const opened = parseInt(open) - 1;
                                if (opened >= 0) {
                                    setOpen(opened);
                                }
                            }}
                            sx={{
                                position: "absolute",
                                top: "50%",
                                left: "20px",
                                transform: "translate(-50%, -50%)",
                                color: "#FFF",
                            }}
                        >
                            <ChevronLeft sx={{ fontSize: 48 }} />
                        </IconButton>
                    )}
                    {parseInt(open) + 1 !== service?.photos?.length && (
                        <IconButton
                            aria-label="Próxima foto"
                            onClick={() => {
                                const opened = parseInt(open) + 1;
                                if (opened < service?.photos?.length) {
                                    setOpen(opened);
                                }
                            }}
                            sx={{
                                position: "absolute",
                                top: "50%",
                                right: "10px",
                                transform: "translate(-50%, -50%)",
                                color: "#FFF",
                            }}
                        >
                            <ChevronRight sx={{ fontSize: 48 }} />
                        </IconButton>
                    )}
                    <img
                        src={open === -1 ? "" :service.photos[open]}
                        alt="imagem de colonias"
                        onClick={handleClose}
                        style={{
                            objectFit: "cover",
                            minWidth: "200px",
                            maxWidth: "60vw",
                        }}
                    />
                </Box>
            </Modal>
            <Grid
                container
                display={"flex"}
                mt={2}
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <Grid xs={12} md={6.1} paddingX={4}>
                    <Typography
                        color="#010101"
                        fontFamily="Raleway"
                        fontStyle="normal"
                        fontWeight="700"
                        fontSize="32px"
                        lineHeight="37.57px"
                    >
                        {service.titulo}
                    </Typography>
                </Grid>
                <Grid xs={12} md={6} paddingX={4}>
                    <div
                        dangerouslySetInnerHTML={{
                            __html: service.ck,
                        }}
                    ></div>
                </Grid>
                <Grid
                    container
                    display={"flex"}
                    mt={2}
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <Grid
                        xs={12}
                        md={8}
                        gap={2}
                        marginTop={6}
                        container
                        marginY={6}
                        display={"flex"}
                    >
                        {photos}
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    );
}

export default ColonyFullPage;
